import '@blocksuite/hive-block-embed/effects';

import { insertEmbedCard } from '@blocksuite/hive-block-embed';
import type { EmbedCardStyle } from '@blocksuite/hive-model';
import { EmbedOptionProvider } from '@blocksuite/hive-shared/services';
import type { Command } from '@blocksuite/std';

export const insertBookmarkCommand: Command<
  { url: string },
  { blockId: string; flavour: string }
> = (ctx, next) => {
  const { url, std } = ctx;
  const embedOptions = std.get(EmbedOptionProvider).getEmbedBlockOptions(url);

  let flavour = 'hive:bookmark';
  let targetStyle: EmbedCardStyle = 'vertical';
  const props: Record<string, unknown> = { url };
  if (embedOptions) {
    flavour = embedOptions.flavour;
    targetStyle = embedOptions.styles[0];
  }
  const blockId = insertEmbedCard(std, { flavour, targetStyle, props });
  if (!blockId) return;
  next({ blockId, flavour });
};
